import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(theme => ({
    errorContent: {
        marginTop: theme.spacing(3),
        backgroundColor: theme.palette.error.dark,
    },
    successContent: {
        marginTop: theme.spacing(3),
        backgroundColor: theme.palette.success.light,
    },
    errorMessage: {
        display: 'flex',
        alignItems: 'center',
    },
    errorSnackbar: {
        [theme.breakpoints.down('xs')]: {
            bottom: 90,
        },
    },
    errorIcon: {
        fontSize: 20,
        opacity: 0.9,
        marginRight: theme.spacing(1),
    },
    errorCloseIcon: {
        fontSize: 20,
    },
}));
